import { render, staticRenderFns } from "./InviteButton.vue?vue&type=template&id=0dacd01a&"
import script from "./InviteButton.vue?vue&type=script&lang=js&"
export * from "./InviteButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports